export const production_chart = (result) => {

    var itemStyle = {
        emphasis: {
            normal: {
            },
            barBorderWidth: 1,
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(0,0,0,0.5)'
        }
    };
    if(Object.keys(result).length > 0){
        return {
            backgroundColor: '#FFFFFF',
            legend: {
                data: ['Brutas', 'Canceladas'],
                orient: "vertical",
                right: "15px",
                top:   "25px",
                show : false
            },
            xAxis: {
                data: result["xAxis"],
                silent: false,
                axisLine: {onZero: true},
                splitLine: {show: true},
                splitArea: {show: false}
            },
            yAxis: {
                inverse: false,
                splitLine: {show: true},
                splitArea: {show: false}
            },
            grid: {
                right: "50px",
                left:"50px",
                top:   "35px",
                bottom : "35px",
                height : "220px"
            },
            series: [
                {
                    name: 'Brutas',
                    type: 'bar',
                    stack: 'one',
                    itemStyle: itemStyle,
                    color: "#15d39a",
                    data: result["current_year"]["totals"],
                    tooltip: {
                        triggerOn: "click",
                        textStyle : {
                            width : "140px"
                        },
                        formatter: '{c0} R/Ns',
                        extraCssText: 'width: auto !important;'
                    },
                },
                {
                    name: 'Canceladas',
                    type: 'bar',
                    stack: 'one',
                    color: "#15d39a",
                    itemStyle: itemStyle,
                    data: result["current_year"]["cancels"],
                    tooltip: {
                        triggerOn: "click",
                        textStyle : {
                            width : "140px"
                        },
                        formatter: '{c0} R/Ns',
                        extraCssText: 'width: auto !important;'
                    },
                    
                },
                {
                    name: 'Brutas',
                    type: 'bar',
                    stack: 'two',
                    itemStyle: itemStyle,
                    color: "#fec400",
                    data: result["last_year"]["totals"],
                    tooltip: {
                        triggerOn: "click",
                        textStyle : {
                            width : "140px"
                        },
                        formatter: '{c0} R/Ns',
                        extraCssText: 'width: auto !important;'
                    },
                },
                {
                    name: 'Canceladas',
                    type: 'bar',
                    stack: 'two',
                    color: "#fec400",
                    itemStyle: itemStyle,
                    data: result["last_year"]["cancels"],
                    tooltip: {
                        triggerOn: "click",
                        textStyle : {
                            width : "140px"
                        },
                        formatter: '{c0} R/Ns',
                        extraCssText: 'width: auto !important;'
                    },
                },
            ]
        };
    }else{
        return {}
    }
}


// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/widgets/Charts.js